import React, { useEffect, useState, useContext } from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { api } from '../api';
import { fetchToken, fetchRole } from '../auth/Token';
import { Box, Button, ButtonGroup, Typography, CircularProgress, FormHelperText, Select, MenuItem } from '@mui/material';
import Alert from '@mui/material/Alert';
import { DataGrid, GridToolbar, GridRowParams, GridActionsCellItem} from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import AuthContext from "../auth/AuthProvider";
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { useFormik, validateYupSchema } from 'formik';
import * as Yup from 'yup';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import Slide from '@mui/material/Slide';
import KPeeLogo from '../LogoKPee.png';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import { Font,PDFDownloadLink } from "@react-pdf/renderer";
import DeleteIcon from '@mui/icons-material/Delete';
import TransactionDetails from './TransactionDetails';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import Autocomplete from '@mui/material/Autocomplete';
import CancelIcon from '@mui/icons-material/Cancel';
import { toast } from 'sonner';

const FormatedDate = ({value}) => {
    const timestamp = value;
    const date = new Date(timestamp);
  
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours() % 12 || 12).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const amOrPm = date.getHours() >= 12 ? 'PM' : 'AM';
  
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes} ${amOrPm}`;
    return <span>{formattedDate}</span>;
  }

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const FormatedDateNoTime = ({value}) => {
    const timestamp = value;
    const date = new Date(timestamp);
  
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
  
    const formattedDate = `${year}-${month}-${day}`;
    return <Text>{formattedDate}</Text>;
  }

  const FormatedDateWithTime = ({value}) => {
    const timestamp = value;
    const date = new Date(timestamp);
  
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours() % 12 || 12).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const amOrPm = date.getHours() >= 12 ? 'PM' : 'AM';
  
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes} ${amOrPm}`;
    return <Text>{formattedDate}</Text>;
  }


export const ShareCert = (props) => {
    const [open, setOpen] = React.useState(true);
    const handleclose = () => {
        setOpen(false);
        props.setOpennn();
    };

    const styles = StyleSheet.create({
      body: {
        margin: 0,
        paddingLeft: 50,
        paddingRight: 50,
        paddingTop: 10,
      },
      header: {
        fontSize: 10,
        marginBottom: 20,
        textAlign: 'center',
        color: 'grey',
      },
      section: {
        flexDirection: 'row',
        padding:0,
        marginBottom:20
      },
      sectionn: {
        flexDirection: 'row',
        padding:0,
        marginBottom:20
      },
      sec1: {
        flex: 1,
        margin: 5,
        paddingLeft:0,
        paddingRight:50,
        fontSize:10
      },
      logo: {
        flex: 1,
        maxWidth: 60,
        height: 50,
        paddingLeft:0,
        border: '1px outset brown',
        marginRight:180,
        marginBottom:5
      },
      sec2: {
        flex: 1,
        margin: 5,
        marginLeft:90,
        paddingRight:0,
        textAlign: 'justify',
        fontSize:10,
        color: '#805b10'
      },
      sec21: {
        flex: 1,
        margin: 5,
        marginLeft:90,
        paddingRight:0,
        textAlign: 'justify',
        fontSize:10
      },
      title: {
        textAlign: 'center',
        textDecoration:'underline'
      },
      salutation: {
        fontSize:10,
        marginBottom:10,
        marginTop:10,
        textAlign: 'left',
      },
      message: {
        fontSize:10,
        fontWeight: 'bold',
        textAlign: 'justify',
      },
      end: {
        color: 'brown',
        fontSize:10,
        fontWeight: 'bold',
        textAlign: 'left',
        marginTop: 6
      },
      important: {
        fontFamily: 'Roboto',
        fontWeight: 900,
        fontSize: 10,
      },
      sec1color: {
        color: '#064F80'
      },
      bold: {
        fontWeight: 'semibold',
        fontWeight: '200',
        color: '#14213d'
      },
      pageNumber: {
        position: 'absolute',
        fontSize: 12,
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'grey',
      },
    });
       

       const MyShareCertificate = () => (
        <Document>
        <Page size="A4" style={styles.body}>
          <Text style={styles.header} fixed>
            ~ The Cooperative ~
          </Text>
          <View style={styles.section}>
            <Image src={KPeeLogo} alt='KPee logo' style={styles.logo} />
                {
                  props.Basic_Info?.community_name?
                    <Text style={styles.sec2}>
                      SOCIETY: <Text style={styles.bold}>{props.Basic_Info?.society}</Text>{'\n'}
                      CLUSTER: <Text style={styles.bold}>{props.Basic_Info?.cluster_name}</Text>{'\n'}
                      COMMUNITY: <Text style={styles.bold}>{props.Basic_Info?.community_name}</Text>{'\n'}
                      SAVINGS GROUP: <Text style={styles.bold}>{props.Basic_Info?.association_name}</Text>{'\n'}
                      PASSBOOK NO.: <Text style={styles.bold}>{props.Basic_Info?.passbook_id}</Text>{'\n'}
                      End Date: <Text style={styles.bold}>{<FormatedDateNoTime value={props.Transaction_Details.ending_date} />}</Text>{'\n'}
                    </Text>
                :<Text style={styles.sec2}>
                      SAVINGS GROUP: <Text style={styles.bold}>{props.Basic_Info?.association_name}</Text>{'\n'}
                      PASSBOOK NO.: <Text style={styles.bold}>{props.Basic_Info?.passbook_id}</Text>{'\n'}
                      End Date: <Text style={styles.bold}>{<FormatedDateNoTime value={props.Transaction_Details.ending_date} />}</Text>{'\n'}
                    </Text>
                }
          </View>
          
          <View style={styles.section}>
            <Text style={styles.sec1}>
              <Text style={styles.sec1color}>From:</Text>{'\n'}
                KIBBUTZ PISHON CO-OPERATIVE{'\n'}
                MUTUAL SUPPORT AND SOCIAL{'\n'}
                SERVICES LIMITED{'\n'}
                P. O. BOX 424, TECHIMAN B/E{'\n'}
                COMMUNITY: {props.Basic_Info.community_name} {'\n'}
                CLUSTER OFFICE: {props.Basic_Info.cluster_name}
              </Text>
            <Text style={styles.sec21}>
            <Text style={styles.sec1color}>To:</Text>{'\n'}
              {`${props.Basic_Info.firstname} ${props.Basic_Info?.middlename} ${props.Basic_Info.lastname}`}{'\n'}
              {props.Basic_Info.address}{'\n'}
              Next of Kin: {props.Basic_Info.nextOfKin}
            </Text>
          </View>

          <Text style={styles.title}>Share Certificate</Text>
          <Text style={styles.salutation}>Dear Mrs/Mr. {`${props.Basic_Info.firstname} ${props.Basic_Info.lastname}`}, </Text>
 

          <Text style={styles.message}>
            Congratulations! Your application for {props.Basic_Info.account_name} with a deposit of <Text style={styles.important}>GHS{props.Basic_Info.amount}</Text> has been approved. 
            This investment is valid for a duration of <Text style={styles.important}>{props.Transaction_Details.period}</Text>, commencing from  
            <Text style={styles.important}> {<FormatedDateNoTime value={props.Transaction_Details.starting_date} />}</Text> to <Text style={styles.important}>{<FormatedDateNoTime value={props.Transaction_Details.ending_date} />}</Text>, 
            with an interest rate of <Text style={styles.important}>{props.Basic_Info.interest_amt.toFixed(2)}%/pa, </Text> 
            and total interest of <Text style={styles.important}>GHS{props.Transaction_Details.interest_rate_amount.toFixed(2)}</Text>. At the end of the investment period,
            the investment would be {props.Transaction_Details.on_due_date} {(props.Transaction_Details.spending_means) ? `and ${props.Transaction_Details.spending_means} account.` : `. `}
            Rest assured that your investment is safe and well-managed throughout its tenure,
            and we look forward to assisting you with your financial goals beyond the maturity date
          </Text>

          <View>
            {/* Table Goes Here */}
          </View>
    
          <Text style={styles.end}>
            Report any issue regarding the loan to our office or call: 0244815594.
          </Text>

        </Page>
      </Document>
      );
      Font.register({
        family: 'Roboto',
        src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-800.ttf',
        fontWeight: 800,
      });
    
      return(
        <>
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleclose}
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle>{"Share Certificate"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                Share Certificate Generated Successfully.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleclose} variant='contained' color='success' sx={{ marginRight:1 }}>Close</Button>
              {/* <Button onClick={handleView}>View</Button> */}
              <PDFDownloadLink document={<MyShareCertificate />} filename="FORM">
                  {({loading}) => (loading ?  <Button variant='contained' color='success'>Loading...</Button> :  <Button variant='contained' color='success'>Download</Button> )}
              </PDFDownloadLink>
             
            </DialogActions>
          </Dialog>
        </>
      )

};













export default function SharesDetails(props) {
    const [info, setInfo] = useState([])
    const [transactionDetails, setTransactionDetails] = useState([]);
    const [savingsDetails, setSavingsDetails] = useState([]);
    const [shareOpen, setShareOpen] = React.useState(false);
    const [shareWithOpen, setShareWithOpen] = React.useState(false);
    const [shareValue, setShareValue] = useState(null);
    const [opennn, setOpennn] = React.useState();
    const [alert, setAlert] = useState();
    const {  permissions } = useContext(AuthContext);
    const [start_date, setStart_date] = useState('')
    const [end_date, setEnd_date] = useState('')

      const [total_wit, setTotal_wit] = useState();
      const [total_dep, setTotal_dep] = useState();

        const fetchTransactions = () => {
          const tj = new FormData()
          tj.append('member_shares_acc_id', props.ID)
          tj.append('start_date', start_date)
          tj.append('end_date', end_date)

            api.post('/transactions/transaction/share/member_shares_acc_id', tj,{
                headers: {
                    Authorization: 'Bearer '+ fetchToken()
                },
            }).then(function (response) {
              setTransactionDetails(response.data?.data)
              setTotal_wit(response.data?.total_wit);
              setTotal_dep(response.data?.total_dep);
            }).catch(function (error) {
                console.log(error)
            })
        }

          const fetchTransactions_unfil = () => {
            setStart_date('')
            setEnd_date('')
            fetchTransactions()
          }



      useEffect(() => {
        fetchTransactions();
      },[props.ID])

        const fetchSavingsAccounts = () => {
            api.get(`/transactions/savings/share/${props.ID}`, {
                headers: {
                    Authorization: 'Bearer '+ fetchToken()
                },
            }).then(function (response) {
              setSavingsDetails(response.data?.Accounts);
            }).catch(function (error) {
                console.log(error)
            })
        }
      useEffect(() => {
        fetchSavingsAccounts();
      },[props.ID])



    
    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        height: '125vh', 
        color: theme.palette.text.secondary,
      }));
    const fetchshareDetails = () => {
      api.get(`/account/share/${props.ID}`,{
          headers: {
              Authorization: 'Bearer ' + fetchToken()
          }
      }).then(function (response){
          setInfo(response.data)
      }).catch(function (error){
        console.log(error)
      })
    }
  const fetchShareValue = async () => {
    await api.get(`/transactions/shform/${props.ID}`,{
        headers: {
            Authorization: 'Bearer ' + fetchToken()
        },
    }).then(function (response) {
        setShareValue(response.data.share_value)

    }).catch(function (error){
        console.log(error)
    })
  }
      useEffect(() => {
        fetchShareValue();
        fetchshareDetails();
      },[])

      const handleClose = () => {
        props.setOpen_acc();
      };

      function handleWithdraw(){
        setShareWithOpen(true)
      };
      function handleWithdrawClos(){
        formikk.handleReset()
        setShareWithOpen(false)
      };

      const handleBuyShares = () => {
        setShareOpen(true)
      };

      function closeShares(){
        formik.handleReset()
        setShareOpen(false)
      }

      function closeSharess(){
        formik.handleReset();
      }

      const [loading, setLoading] = useState(false);
      const [check_amount, setCheck_amount] = useState(null);
      const formik = useFormik({
        initialValues: {
            transactiontype_id: 1,
            Amount: null,
            narration: '',
            shares_acc_id: props.ID,
            period: null,
            on_due_date: '',
            spending_means: '',
            account_name: '',
            account_id: null
        },
        validationSchema: Yup.object({
            Amount: Yup.number()
                .required('Specify Amount of Shares').min(0).max(check_amount),
            narration: Yup.string(),
            on_due_date: Yup.string('Field is required'),
            spending_means: Yup.string('Field is required'),
            period: Yup.number('Field is required')
        }),
        onSubmit: (values) => {
          const valus = {
            to_accountType: 'shares',
            Amount: values.Amount,
            savings_acc_id: values.account_id,
            to_member_account_id: values.shares_acc_id,
            period: values.period,
            on_due_date: values.on_due_date,
            spending_means: values.spending_means,
            account_name: values.account_name
          }
          if(check_amount < (values.Amount * shareValue)){
            toast.error('Insufficient  Funds');
          }else{
            setLoading(true)
            api.post('/transactions/transfer', valus , {
                headers: {
                    Authorization:'Bearer ' + fetchToken(),
                },
            }).then(function (response) {
                toast.success(response.data)
                formik.handleReset()
                closeShares()
            }).catch(function (error){
                // setAlert(<Alert severity="error">{error.response.data.detail}</Alert>)
                console.log(error)
            }).finally(function (){
              setLoading(false)
              setAlert()
              fetchTransactions()
              fetchShareValue();
              fetchshareDetails();
            })
          }

        }
      })

      const formikk = useFormik({
        initialValues: {
            transactiontype_id: 2,
            Amount: null,
            narration: '',
            shares_acc_id: props.ID
        },
        validationSchema: Yup.object({
            Amount: Yup.number()
                .required('Specify Amount of Shares').min(0),
            narration: Yup.string()
        }),
        onSubmit: (values) => {
          setLoading(true)
            // console.log(values)
            api.post('/transactions/transaction/share/wit', values , {
                headers: {
                    Authorization:'Bearer ' + fetchToken(),
                },
              }).then(function (response) {
                toast.success(response.data)
                formikk.handleReset()
                handleWithdrawClos()
                closeSharess()
              }).catch(function (error){
                  // setAlert(<Alert severity="error">{error.response.data.detail}</Alert>)
                  console.log(error)
              }).finally(function (){
                setLoading(false)
                setAlert()
                fetchTransactions()
                fetchShareValue();
                fetchshareDetails();
              })
        }
      })
      const type = "share"
      const savings_acc_id = props.ID

      const columns = [
        {
            field: "action",
            type: 'actions',
            headerName: "Share Certificate",
            flex:1,
            width: 70,
            getActions: (params: GridRowParams) => [
              <GridActionsCellItem
              icon={<VisibilityOutlinedIcon />}
              onClick={() => printShareCert(params.row.transaction_id)} 
              label="Open"
            />]
        },
        {
            field: "transaction_date",
            headerName: 'DateTime',
            flex: 1,
            cellClassName: "name-column--cell",
            renderCell:(params) => <FormatedDate value={params.row.transaction_date}/>
        },
        {
            field: "narration",
            headerName: "Narration",
            flex:1,
            width: 70,
        },
        {
          field: "debit",
          headerName: "Debit(GHS)",
          flex:1,
          width: 70,
          renderCell:(params) => (params.row.transactiontype_name === "Withdraw")? params.row.amount : 0
        },
        {
            field: "credit",
            headerName: "Credit(GHS)",
            flex:1,
            width: 70,
            renderCell:(params) => (params.row.transactiontype_name === "Deposit")? params.row.amount : 0
        },
        {
            field: "balance",
            headerName: "Account Balance",
            flex:1,
            width: 70,
        },
        {
            field: "transaction_id",
            headerName: "Id",
            flex:1,
            width: 70,
        },
        {
            field: "transactiontype_name",
            headerName: "Type",
            flex:1,
            width: 70,
            renderCell: (params) => {
                if (params.row.transactiontype_name === "Deposit"){
                    return "Purchase"
                }else{
                    return "Withdraw"
                }
            }
        },
        {
            field: "amount",
            headerName: "Amount(GH₵)",
            flex:1,
            width: 70,
        },
        {
            field: "username",
            headerName: "Prepared by",
            flex:1,
            width: 70,
        },
        
        {
          field: "update",
          type:'action',
          headerName: "Action",
          // flex: 1,
          width:20,
          renderCell: (params) => <TransactionDetails {...{params, type, info, savings_acc_id, fetchTransactions, fetchshareDetails }} />
      },
        {
            field: 'delete',
            type: 'actions',
            width:20,
            getActions: (params: GridRowParams) => [
            <GridActionsCellItem
            icon={<DeleteIcon />}
            onClick={() => handleClickOpen(params.row.transaction_id)} 
            label="Open"
            />,]
        },
      ]
      const [messageid, setMessageid] = useState();
      const [openn, setOpenn] = useState(false);

      const handleClickOpen = (id) => {
            setOpenn(true);
            setMessageid(id)
      }

      const handleDelete = () => {
        const id = messageid
        try {
            api.delete(`/transactions/transaction/shares/${id}`,{
             headers :{
               Authorization: 'Bearer '+ fetchToken()
             }
           }).then(function (response){
                toast.success(response.data)
                setOpenn(false)
                fetchShareValue();
                fetchshareDetails();
                if(response.data === "Account Deleted"){
                  props.fetchAccounts();
                   handleClose(); 
               }
           }).catch(function (error){
                console.log(error)
           })
         } 
         catch(error){
         console.log(error )
       };
    };

      const printShareCert = async (id) => {
        if(permissions && permissions.download_share_cert === true){
          await api.get(`/transactions/share/slip/${id}`, {
            headers: {
              Authorization: 'Bearer '+ fetchToken()
            },
          }).then(function (response){
              setOpennn(<ShareCert Basic_Info={response.data?.Basic_Info} Transaction_Details={response.data?.Transaction_Details} setOpennn={setOpennn} />)
          }).catch(function (error){
            console.log(error);
          });
        }else{
          toast.error("Not Authorized")
        }
      };

      const [open, setOpen] = useState(false);

    const handleDeleteAcc = () =>{
        api.delete(`account/delete_acc/share/${props.ID}`, {
            headers: {
                Authorization: 'Bearer '+fetchToken()
            },
        }).then(function (response){
            setOpen(false);
            toast.success(response.data);
            if(response.data === "Account Deleted"){
               props.fetchAccounts();
                handleClose(); 
            }
        }).catch(function (error){
            console.log(error);
        })
    }


    const CustomFooterRow = () => {
      return (
        <div>
          <div style={{ display: 'flex', padding: '4px' }}>
            <Typography variant="h5" sx={{ color:'red', mr:4 }}>Total:</Typography>
            <Typography variant="h5" sx={{ color:'darkblue', mr:4 }}>Debit: {total_wit} </Typography>
            <Typography variant="h5" sx={{ color:'darkblue', mr:4 }}>Credit: {total_dep} </Typography>
           </div>
        </div>
      );
  };

  const currencyFormat = new Intl.NumberFormat('en-GH', {
    style: 'currency',
    currency: 'GHS',
  });

  return (
    <div>
        <Item>
            <Box
                sx={{
                     display:'flex',
                     justifyContent:'space-between'
                    }}
            ><Button onClick={handleClose} variant='contained' color='warning'>Close</Button>
                <Typography>Current Balance: {info[0]?.current_balance}</Typography>
                <Typography variant='h4' sx={{ fontWeight: '700',color:'darkblue' }}>{props.name}</Typography>
                <Typography>Open date: {info[0]?.open_date}</Typography>
            </Box>
            {opennn}
            <Box
                sx={{ 
                    display:'flex-end'
                 }}
            >
              {
                permissions && permissions.create_shares_transactions === true?
                <ButtonGroup variant="contained" aria-label="outlined primary button group">
                    <Button onClick={handleBuyShares}>Buy Shares</Button>
                    <Button onClick={handleWithdraw}>Withdraw</Button>
                </ButtonGroup>
                :null
              }
                

            </Box>
            <Box
                m="40px 0 0 0"
                height="95vh"
                paddingBottom="55px"
            >
              {
                permissions && permissions.view_share_transactions === true?
                <>
                      <Typography variant='h3' sx={{ marginBottom:'10px' }}>Shares Transactions</Typography>
                      <>
                <Typography>Filter Date</Typography>
                <div style={{ display:'flex' }}>
                <TextField
                    type='date'
                    size="small"
                    required
                    variant="outlined"
                    helperText="From"
                    name="start_date"
                    onChange={(e) => setStart_date(e.target.value)}
                    value={start_date}
                    sx={{ mr:1 }}
                />

                <TextField
                    type='date'
                    size="small"
                    required
                    variant="outlined"
                    helperText="To"
                    name="end_date"
                    onChange={(e) => setEnd_date(e.target.value)}
                    value={end_date}
                    sx={{ mr:1 }}
                />

                <IconButton sx={{ mb:2 }} onClick={fetchTransactions}><FilterAltOutlinedIcon /></IconButton>
                <IconButton sx={{ mb:2 }} onClick={fetchTransactions_unfil}><CancelIcon /></IconButton>
                </div>
                </>
                <DataGrid
                    rows={transactionDetails}
                    columns={columns}
                    checkboxSelection
                    getRowId={(row) => row.transaction_id}
                    slots={{ toolbar: GridToolbar, footer: CustomFooterRow }}
                    initialState={{
                      columns: {
                        columnVisibilityModel: {
                          transaction_id: false,
                          amount:false,
                          username:false,
                          transactiontype_name:false
                        },
                      },
                    }}
                />
                </>
                :null
              }
                
            </Box>

              <Button
                sx={{ mt:7 }}
                onClick={()=>setOpen(true)}
                variant='contained'
                color='warning'
              >
                Delete Account
              </Button>
        </Item>
        <Dialog open={shareOpen} onClose={closeShares}>
            <form onSubmit={formik.handleSubmit}>
            <DialogTitle>Transaction</DialogTitle>
            <DialogContent>
            <DialogContentText>
                Buy Shares
            </DialogContentText>
            <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={savingsDetails}
                sx={{ width: 300 }}
                getOptionLabel={(option) => `${option.account_name} (${currencyFormat.format(option.current_balance)})`}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(event, value) => {
                    if (value) {
                        formik.setFieldValue('account_id', value.id)
                        setCheck_amount(value.current_balance)
                    }
                }}
                renderInput={(params) => <TextField {...params} label="Select account" />}
            />
            {
              formik.values.account_id?
            <>
              <p>1 Share = GH₵{shareValue}.00</p>
            <TextField
                margin="dense"
                id="Amount"
                name="Amount"
                label="Amount"
                onChange={formik.handleChange}
                value={formik.values.Amount}
                onBlur={formik.handleBlur}
                error={formik.touched.Amount && Boolean(formik.errors.Amount)}
                helperText={formik.touched.Amount && formik.errors.Amount}
                type="number"
                fullWidth
                variant="outlined"
            />
            <Typography sx={{ fontWeight: '700' }}>Share Value: {currencyFormat.format(formik.values.Amount * shareValue)}</Typography>

            <TextField
                margin="dense"
                id="narration"
                name="narration"
                label="Narration (optional)"
                onChange={formik.handleChange}
                type="text"
                value={formik.values.narration}
                onBlur={formik.handleBlur}
                error={formik.touched.narration && Boolean(formik.errors.narration)}
                helperText={formik.touched.narration && formik.errors.narration}
                fullWidth
                variant="outlined"
            />
            <FormHelperText>Set period</FormHelperText>
            
            <Select
                margin="dense"
                disabled={(formik.values.period)? true :false}
                id="period"
                required
                name="period"
                onChange={formik.handleChange}
                type="date"
                value={formik.values.period}
                helperText="Set Period"
                fullWidth
                variant="outlined"
                sx={{ marginBottom:1 }}
            >
                <MenuItem value={null}>Or Set number of Years</MenuItem>
                <MenuItem value={0.25}>3 months</MenuItem>
                <MenuItem value={0.5}>6 months</MenuItem>
                <MenuItem value={1}>1 year</MenuItem>
            </Select>

            <Typography>OR</Typography>
            <FormHelperText>Set Number of years</FormHelperText>
            <TextField
                margin="dense"
                disabled={(formik.values.period)? true :false}
                id="period"
                required
                name="period"
                onChange={formik.handleChange}
                type="number"
                value={formik.values.period}
                onBlur={formik.handleBlur}
                error={formik.touched.period && Boolean(formik.errors.period)}
                helperText={formik.touched.period && formik.errors.period}
                // helperText="Set Number of years"
                fullWidth
                variant="outlined"
                sx={{ marginBottom:5 }}
            />
            <FormHelperText>What actions are taken on the date when the share ends?</FormHelperText>
            <Select
                required
                margin="dense"
                id="on_due_date"
                name="on_due_date"
                label="Action that would be taken on due date"
                onChange={formik.handleChange}
                value={formik.values.on_due_date}
                onBlur={formik.handleBlur}
                error={formik.touched.on_due_date && Boolean(formik.errors.on_due_date)}
                helperText={formik.touched.on_due_date && formik.errors.on_due_date}
                fullWidth
                sx={{ marginBottom:1 }}
                variant="outlined"
            >
                <MenuItem value="rolled over with interest">Roll Over With Interest</MenuItem>
                <MenuItem value="rolled over without interest">Roll Over Without Interest</MenuItem>
                <MenuItem value="canceled">End</MenuItem>
            </Select>
            

            <Select
                // margin="dense"
                disabled={(formik.values.on_due_date === "rolled over with interest")? true :false}
                id="spending_means"
                name="spending_means"
                label="Action to be taken on after end date"
                onChange={formik.handleChange}
                value={formik.values.spending_means}
                onBlur={formik.handleBlur}
                error={formik.touched.spending_means && Boolean(formik.errors.spending_means)}
                helperText={formik.touched.spending_means && formik.errors.spending_means}
                fullWidth
                variant="outlined"
            >
                <MenuItem value="transferred to your ">Transfer to Savings Account</MenuItem>
                <MenuItem value="withdrawn">Withdraw</MenuItem>
            </Select>
            <Select
                // margin="dense"
                disabled={(formik.values.spending_means === "transferred to your ")? false:true }
                id="account_name"
                name="account_name"
                label="Set Savings Account"
                onChange={formik.handleChange}
                value={formik.values.account_name}
                helperText="Set Account"
                fullWidth
                sx={{ marginTop:1 }}
                variant="outlined"
            >
              {savingsDetails.map((item) => (
                <MenuItem key={item.id} value={item.account_name}>{item.account_name}</MenuItem>
              ))}    
            </Select></>
              : null
            }
            </DialogContent>

            <DialogActions>
            <Button variant='contained' color='success' onClick={closeShares}>Cancel</Button>
            <Button variant='contained' color='success' onClick={closeSharess}>Reset</Button>
            <Button
                 type='submit'
                 color='success'
                 variant='contained'
                 disabled={formik.values.account_id === null}
                >
                    { loading === true ? 
                     <Box sx={{ width: '100%' }}>
                        <CircularProgress />
                    </Box>
                    :
                    "Buy"
                    }
                </Button>
            </DialogActions>
            
            
            </form>
        </Dialog>

        {/* Shares Withdrawal */}

        <Dialog open={shareWithOpen} onClose={handleWithdrawClos}>
            <form onSubmit={formikk.handleSubmit}>
            <DialogTitle>Transaction</DialogTitle>
            <DialogContent>
            <DialogContentText>
                Withdraw Shares
            </DialogContentText>
            <p>1 Share = GH₵{shareValue}.00</p>
            <TextField
                margin="dense"
                id="Amount"
                name="Amount"
                label="Amount(specify value to withdraw)"
                onChange={formikk.handleChange}
                value={formikk.values.Amount}
                onBlur={formikk.handleBlur}
                error={formikk.touched.Amount && Boolean(formikk.errors.Amount)}
                helperText={formikk.touched.Amount && formikk.errors.Amount}
                type="number"
                fullWidth
                variant="outlined"
            />
            Share Value:
            <Typography sx={{ fontWeight: '700' }}>GH₵{formikk.values.Amount * shareValue}.00</Typography>
            <TextField
                margin="dense"
                id="narration"
                name="narration"
                label="Narration (optional)"
                onChange={formikk.handleChange}
                type="text"
                value={formikk.values.narration}
                onBlur={formikk.handleBlur}
                error={formikk.touched.narration && Boolean(formikk.errors.narration)}
                helperText={formikk.touched.narration && formikk.errors.narration}
                fullWidth
                variant="outlined"
            />
            
            </DialogContent>
            <DialogActions>
            <Button onClick={handleWithdrawClos}>Cancel</Button>
            <Button
                 type='submit'
                >
                    { loading === true ? 
                     <Box sx={{ width: '100%' }}>
                        <CircularProgress />
                    </Box>
                    :
                    "Withdraw"
                    }
                </Button>
            </DialogActions>
            </form>
        </Dialog>
        <Dialog
            open={openn}
            onClose={() =>setOpenn(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
            {"Delete Transaction"}
            </DialogTitle>
            <DialogContent>
            <DialogContentText id="alert-dialog-description">
                This action cannot be undone. NB: this will also affect the
                current balance of the account.
                Do you wish to continue?
            </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={() =>setOpenn(false)}>Cancel</Button>
            <Button onClick={handleDelete} autoFocus>
                Continue
            </Button>
            </DialogActions>
        </Dialog>
         
              <Dialog
                    open={open}
                    onClose={() =>setOpen(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                    {"Delete Account"}
                    </DialogTitle>
                    <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        This action cannot be undone. NB: this will also delete all
                        transactions in this account. As well as Share Certificates.
                        Do you wish to continue?
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleDeleteAcc} autoFocus>
                        Continue
                    </Button>
                    </DialogActions>
                </Dialog>
    </div>
  )
}
